import BasePage from "./basePage";

export default class Page1 extends BasePage{
    constructor(info){
        super(info);
        super.set();

        this.ele = info.ele;
        this.pageTl = new TimelineMax({ paused: true, ease: Power2.easeOut });
        this._pageSet();
        this._bindEvent();
        this._layerVideo();

        this.player1 = new nc.promokit.Player({
            selector: '#sec1-player',
            videoId: 'https://vod.plaync.com/BS/old/190612_archery/index_main_bg.mp4',
            mute: true,
            controls: false,
            coverClick: false,
            loop: true
        });
    }



    _pageSet(){
        this.pageTl
            .fromTo( this.ele.querySelector('.tit span'), 1, { y: "110%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, delay: 0.4, ease: Back.easeOut.config(1.05) })
            .fromTo( this.ele.querySelector('.txt-1 span'), 1, { y: 60, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Back.easeOut.config(1.1) }, "-=0.65")
            .fromTo( this.ele.querySelector('.txt-2 span'), 1, { y: 60, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Back.easeOut.config(1.2) }, "-=0.6")

            .fromTo( this.ele.querySelector('.btn-play'), 0.5, { y: 40, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut })
            .fromTo( this.ele.querySelector('.update'), 0.5, { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, "-=0.3")
            .fromTo( this.ele.querySelector('.btn-scroll'), 0.5, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, "-=0.3")
            .fromTo( this.ele.querySelector('.link'), 0.5, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, "-=0.6")

        // TweenMax.fromTo("#nav .btn-arrow", 1, { x: 36, autoAlpha: 0}, { x: 0, autoAlpha: 1, delay: 3.5, ease: Power2.easeOut });
    }

    _pageChar(){
        let timeLine = new TimelineMax({ pause: false });
        if( Math.floor((Math.random() * 2) + 1 ) == 1 ){
            $( this.ele.querySelector('.char') ).addClass('char-1');
            timeLine
                .fromTo( this.ele.querySelector('.char'), 1, { x: 40, scale: 1, autoAlpha: 0 }, { x: 0, scale: 1, autoAlpha: 1, delay: 1.9, ease: Power2.easeOut })
                .fromTo( this.ele.querySelector('.char .bg-1'), 0.5, { scale: 0.5, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, ease: Back.easeOut }, "-=0.5")
                .fromTo( this.ele.querySelector('.char .bg-2'), 0.5, { scale: 0.7, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, ease: Back.easeOut }, "-=0.45")
        }
        else{
            $( this.ele.querySelector('.char') ).addClass('char-2');
            timeLine
                .fromTo( this.ele.querySelector('.char-2'), 1, { x: 20, y: -60, autoAlpha: 0 }, { x: 0, y: 0, autoAlpha: 1, delay: 1.9, ease: Power2.easeOut })
                .fromTo( this.ele.querySelector('.char-2 .bg-1'), 0.5, { x: -40, y: 80, autoAlpha: 0 }, { x: 0, y: 0, autoAlpha: 1, ease: Power4.easeOut }, "-=0.5")
                .fromTo( this.ele.querySelector('.char-2 .bg-2'), 0.5, { scale: 0.7, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, ease: Back.easeOut }, "-=0.45")
        }
    }

    _pageMotion(){
        this.player1.seek(0);
        this.player1.play();
        this.pageTl.restart();
        this._pageChar();

    }

    _bindEvent(){
        this.ele.addEventListener('onComplete', this._pageMotion.bind(this) );


    }

    show(){
        super.show();

    }

    hide(){
        super.hide();

        this.player1.pause();
        setTimeout(()=>{
            this.pageTl.reverse();
            $('.section-1 .char').removeClass('char-1');
            $('.section-1 .char').removeClass('char-2');
        }, 500)
    }

    _layerVideo(){
        let layer = new nc.promokit.Layer({
            'el': '#layer-1',
            'fade': true,
            'esc': true,
            'dim': true,
            'dimClickClose': true,
        });

        let layerVideo = new nc.promokit.Player({
            selector: '#layer-player-1',
            videoId: 'PJH3ZurtlCQ',
            mute: false,
            controls: true,
            coverClick: true,
            loop: false
        });

        $('.section-1 .btn-play').on('click', function(){
            layerVideo.seek(0.1);
            layerVideo.play();
            layer.open();
        });

        $('.layer .btn_close').on('click', function(){
            layer.close();
        });

        layer.on('layercloseend', function(){
            layerVideo.pause();
        });
    }
}


// WEBPACK FOOTER //
// ./src/js/mainDeath/page1.js